import script from "./castOrDirectorList.vue?vue&type=script&lang=ts&setup=true"
export * from "./castOrDirectorList.vue?vue&type=script&lang=ts&setup=true"

import "./castOrDirectorList.vue?vue&type=style&index=0&id=74b99ea7&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b99ea7"]])

export default __exports__